import { includes } from 'lodash';

export const useStoresBadges = () => {
    const availableLanguages = ['en', 'es', 'pt'];
    const storedLanguage = localStorage.getItem('i18nextLng');
    const language = includes(availableLanguages, storedLanguage) && storedLanguage ? storedLanguage : 'en';
    const appStoreBadgeURL = `${language}/app_store.svg`;
    const googlePlayBadgeURL = `${language}/google_play.png`;

    return {
        appStoreBadgeURL,
        googlePlayBadgeURL
    };
};
